import { PriceTierListResponseType } from "@sellar-io/api-v2/types";

const filterDiscountsWithContainerType = ({
  priceTierDiscountList,
  containerType,
}: {
  priceTierDiscountList: PriceTierListResponseType[number]["PriceTierDiscounts"];
  containerType: "bottle" | "can";
}) => {
  return priceTierDiscountList.filter(
    (priceTierDiscount) =>
      containerType === priceTierDiscount.itemType ||
      priceTierDiscount.itemType === null, // 'any' container type
  );
};

export const getPriceTiersWithDiscountContainerType = ({
  priceTierList,
  containerType,
}: {
  priceTierList: PriceTierListResponseType;
  containerType: "bottle" | "can";
}) => {
  return priceTierList
    .filter((priceTier) => {
      return !!filterDiscountsWithContainerType({
        priceTierDiscountList: priceTier.PriceTierDiscounts,
        containerType,
      }).length;
    })
    .map((priceTier) => {
      const priceTierDiscounts = filterDiscountsWithContainerType({
        priceTierDiscountList: priceTier.PriceTierDiscounts,
        containerType,
      });

      return {
        ...priceTier,
        PriceTierDiscounts: priceTierDiscounts,
      };
    });
};
